import React, {
  useState,
  useContext,
  forwardRef,
  useRef,
  useEffect,
  useImperativeHandle,
  useCallback,
} from 'react';
import { Mentions, Button } from 'antd';
import debounce from 'lodash/debounce';
import { useComment } from './CommentProvider';
import CommentListCtx from './CommentListCtx';
// import CommentListCtx from './../CommentListCtx';

const { Option } = Mentions;
const CommentInput = forwardRef(
  (
    {
      threadIdx,
      commentIdx,
      isThreadInput,
      scrollToThreadTop,
      value,
      setEdit,
      emitInputStatus,
      module,
      emails,
      component = '',
      isEditInput,
      sendIdentifier,
      ...restProp
    },
    ref,
  ) => {
    // debugger;
    const noBorderTop = isEditInput || isThreadInput;
    const mentionRef = useRef();
    const popupRef = useRef();
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showBottom, setShowBottom] = useState(true);
    const [atData, setAtData] = useState([]);

    const [user, setUser] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const { fetchUser, addComment, addThread, editComment } = useComment();
    const { scrollList, handleActiveInput, activeInput } =
      useContext(CommentListCtx);

    useEffect(() => {
      setAtData(
        Array.isArray(emails) ? emails.filter((i) => i && i !== 'null') : [],
      );
    }, [emails]);

    useImperativeHandle(ref, () => ({
      setShow(state) {
        setShow(state);
        changeInputText('');
        setDisabled(true);
      },
      setShowBottom(state) {
        setShowBottom(state);
      },
      setShowEdit(state) {
        setShow(state);
        setDisabled(false);
      },
      getShowStatus() {
        return show;
      },
    }));

    const onSearch = async (search) => {
      setLoading(true);
      debounce(async () => {
        const res = await fetchUser(search);
        setLoading(false);
        setUser(res);
      }, 800)();
    };

    const changeInputText = (v) => {
      if (mentionRef.current?.state) {
        mentionRef.current.state.value = v;
      }
    };

    useEffect(() => {
      if (value && mentionRef.current.state) {
        let res = value.replace(/<span[^>]*>([^<]+)<\/span>/g, (word) => {
          let w = word.replace(/<span[^>]*>/g, '').replace(/<\/span>/g, ':');
          w = w.split(':');
          w.pop();

          // const wArr = w.map((item) => ({ name: item }));
          // setAtData(wArr);
          return w.join('');
        });

        res = res.replace(/<a[^>]*>([^<]+)<\/a>/g, (link) => {
          let l = link.replace(/<a[^>]*>/g, '').replace(/<\/a>/g, ';');
          l = l.split(';');
          l.pop();

          return l.join('');
        });

        mentionRef.current.state.value = res;
      }
    }, [show]);

    const handleData = (v) => {
      let res = v;
      let newAtData = [];
      const newArr = atData.reduce((prev, cur) => {
        // null or undefined value should not be pushed into array
        // if (!cur) {
        //   prev.push(cur);
        // } else {
        //   !prev.find((item) => item?.email === cur?.email) && prev.push(cur);
        // }
        if (cur) {
          !prev.find((item) => item?.email === cur?.email) && prev.push(cur);
        }
        return prev;
      }, []);
      // const data = atData.filter(item=>item.email);

      const linkRegex = new RegExp(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
        'g',
      );

      res = res.replace(linkRegex, (link) => {
        let hrefLink = link;
        if (!link.startsWith('http')) {
          hrefLink = `https://${link}`;
        }
        return `<a href=${hrefLink} target="_blank">${link}</a>`;
      });

      console.log('newArr: ', JSON.stringify(newArr));
      newArr.forEach((item) => {
        // 这里email是a标签
        const { name, email } = item;
        console.log('email: ', email);
        let nameRegex;
        const isClientName = name.includes('(Client)');
        if (isClientName) {
          nameRegex = new RegExp(
            `${name.split('(Client)')[0]}\\(Client\\)`,
            'g',
          );
        } else {
          nameRegex = new RegExp(`${name}`, 'g');
        }
        // 纯email字符串
        const reg = /((\w+):\/\/)?([\w.]+[.]{1})[\w]+/;
        const pureEmail = email.match(reg)[0];
        console.log('pureEmail: ', pureEmail, res);
        res = res?.replace?.(nameRegex, (name) => {
          newAtData = [
            ...newAtData,
            atData.filter(
              (item) =>
                item.name === name ||
                (item.name?.startsWith(name) && isClientName),
            )[0],
          ];
          return `<span class="atName" title="${email}" data-email="${email}">${name}</span>`;
        });
      });

      setAtData(newAtData);
      // const findEmail = atData.map((item) => item.name === res);
      return { v: res, emails: newAtData };
    };

    // const getEmails = () => atData.map((item) => item.email);

    const handleReply = (e) => {
      e.isPropagationStopped();
      console.log(
        'mentionRef: ',
        mentionRef.current,
        mentionRef.current.state,
        e,
      );
      if (!mentionRef.current) {
        return;
      }
      const originV = mentionRef.current?.state?.value || '';

      const { v, emails } = handleData(originV);

      if (!originV.trim()) {
        return;
      }
      isThreadInput
        ? addThread({
            module,
            component,
            comment: v,
            emails,
            identifier: sendIdentifier,
          })
        : isEditInput
        ? editComment('EDIT', {
            ...restProp,
            module,
            component,
            comment: v,
            emails,
          })
        : addComment({
            ...restProp,
            identifier: sendIdentifier || restProp.identifier,
            module,
            component,
            comment: v,
            emails,
          });
      changeInputText('');
      // handleCancel();
      !isThreadInput && handleCancel();
      scrollToThreadTop && scrollList({ toTop: true });
      isThreadInput && scrollList({ toTop: true });
      emitInputStatus && emitInputStatus(false);
      handleActiveInput(-3);
      setDisabled(true);
      setAtData([]);
    };

    const handleCancel = (e) => {
      e && e.isPropagationStopped();
      changeInputText('');
      !isThreadInput && setShow(false);
      // changeShowInput && changeShowInput(false);
      isThreadInput && setShowBottom(false);
      emitInputStatus && emitInputStatus(false);
      handleActiveInput(-3);
      // setEdit && setEdit(false);
      setDisabled(true);
    };
    const handleShowBottom = () => {
      isThreadInput && setShowBottom(true);
      isThreadInput && handleActiveInput('threadComment');
    };

    useEffect(() => {
      if (isThreadInput && activeInput[0] !== 'threadComment') {
        changeInputText('');
        setShowBottom(false);
      }
    }, [activeInput]);

    const handleSelect = (option, prefix, e) => {
      const data = [...atData];
      const { value } = option;
      option.value &&
        data.push({
          email: option.children[1]?.props?.children,
          name: `${prefix}${value}`,
        });
      setUser([]);
      setAtData(data);
    };

    const handleOnchange = (v) => {
      // debugger;
      if (!v.trim()) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    };

    const filterOption = useCallback((text, optionProps = {}) => {
      if (text) {
        const textLowerCase = text.toLowerCase();
        return (
          optionProps.value?.toLowerCase().includes(textLowerCase) ||
          optionProps.email?.toLowerCase().includes(textLowerCase)
        );
      }
      return true;
    }, []);

    return (
      <div
        className={`comment-add ${show ? 'active' : ''} ${
          noBorderTop && `noBorderTop`
        }`}
        ref={popupRef}
      >
        <div
          className={`add-comment thread-${
            isThreadInput ? 'is-add-thread' : threadIdx
          } `}
        >
          <div
            className="add-comment-input "
            onClick={(e) => e.stopPropagation()}
          >
            <Mentions
              ref={mentionRef}
              style={{ height: 35 }}
              loading={loading}
              onSearch={onSearch}
              placeholder="Comment or add others with @"
              getPopupContainer={() => popupRef.current}
              notFoundContent={<div style={{ display: 'none' }}>NO DATA</div>}
              onSelect={handleSelect}
              onFocus={handleShowBottom}
              onChange={handleOnchange}
              filterOption={filterOption}
            >
              {user.map(({ fullName, email, name, isInternal }) => (
                <Option
                  key={email}
                  value={`${name || fullName} ${!isInternal ? `(Client)` : ''}`}
                  className="at-name-option"
                  email={email}
                >
                  <div>
                    {name || fullName}
                    {!isInternal ? `(Client)` : ''}
                  </div>
                  <div className="email">{email}</div>
                </Option>
              ))}
            </Mentions>
          </div>
          {showBottom && (
            <div className="btn-group" onClick={(e) => e.stopPropagation()}>
              <Button kind="secondary" size="sm" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                kind="primary"
                size="small"
                onClick={handleReply}
                disabled={disabled}
              >
                {isEditInput ? 'Save' : 'Comment'}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default CommentInput;
